// Mirrors the server's CREATION_KINDS (src/v2/library-store.ts): a v1 story
// and the Story Studio's items. A kind offered here that the server does not
// know is dropped from the filter there. (No "library" kind since server 0092:
// a creator's small values are rows of their own tables.)
export const CREATION_KINDS = ["story", "world", "voice", "style", "draft", "bin"] as const;

export const kindColor = (kind: string): "default" | "primary" =>
  kind === "story" ? "default" : "primary";

export const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};
